angular.module('SpidApp')

.controller('VacationController',
		['BASE_PUBLIC_URL', '$scope', '$state', '$rootScope', '$localStorage', '_', 'UserService', 'VacationService', 'Vacation', 'Cash', 'CashService', '$q', 'ConfigService', 'Toaster', 'SaleService', 'Drawer',
		 'TransactionService', 'User', '$stateParams', 'BusinessDayService', 'AgencyService', 'VacationDecorator', 'BusinessDay', 'Conversion', 'ConversionRounded', 'MoneyTransferService','Sale',
function (BASE_PUBLIC_URL,   $scope,   $state,   $rootScope,   $localStorage,   _,   UserService,   VacationService,   Vacation,   Cash,   CashService,   $q,   ConfigService,   Toaster,   SaleService,   Drawer,
	      TransactionService,   User,   $stateParams,   BusinessDayService,   AgencyService,   VacationDecorator,   BusinessDay,   Conversion,  ConversionRounded,  MoneyTransferService, Sale) {
	
	var targetVacationId = +$stateParams.id
	var isoDate = moment().toISOString().substr(0, 10)
	
	$scope.vacationOngoing = null
    $scope.currentVacation = null
    $scope.startTotal = 0;
	$scope.canOpen = true;
	$scope.coins = []
	$scope.bills = []
	
	$scope.vacation = new Vacation({
		  amount_start   : null
		, start_transfer : 0
		, stop_transfer  : 0
	})

	$scope.setStopTransfer = function () {
		var amount = ($scope.cumulated - $scope.currentVacation.stopTransfer === 0) ? 0 : ($scope.cumulated - $scope.currentVacation.stopTransfer).toFixed(2);
		$scope.currentVacation.stopDrawer = amount;
	}
	
	$scope.setStopDrawer = function () {
		var amount = ($scope.cumulated - $scope.currentVacation.stopDrawer === 0) ? 0 : ($scope.cumulated - $scope.currentVacation.stopDrawer).toFixed(2);
		$scope.currentVacation.stopTransfer = amount;
	}
	
	var reinitBillsAndCoins = function () {
		AgencyService.find($rootScope.configs.agencyId).then(function (agency) {
			var normCashValue = function (cashValue) {
				return { value: cashValue, quantity: 0 }
			}

			$scope.coins = _.map(agency.currency.coins, normCashValue)
			$scope.bills = _.map(agency.currency.bills, normCashValue)
		})
	}
	
	var getAllActiveVacation = function(){
		return VacationService.allActive().then(function(data) {
			$scope.aVacations = _.where(data, {idAgency: $scope.agency.id});
			
			_.each($scope.aVacations, function (vacation) {
				UserService.find(vacation.idUser).then(function (user) {
					vacation.user = user
				})
			})
		})
	}

	var _closeVacation = function () {
		var bills = $scope.bills
		var coins = $scope.coins

		return CashService.save(Cash.deno(bills, coins), { vacationId: $scope.currentVacation.id }).then(function () {
			return VacationService.find($scope.configs.agencyId, $scope.currentVacation.id)
			
		}).then(function (vacation) {
			vacation.comment      = $scope.currentVacation.comment
			vacation.stopTransfer = +$scope.currentVacation.stopTransfer
			
			var totalBills = bills.reduce(function (memo, e) { return memo + (+e.value) * (+e.quantity) }, 0.0)
			var totalCoins = coins.reduce(function (memo, e) { return memo + (+e.value) * (+e.quantity) }, 0.0)
			
			vacation.stop_total = totalBills + totalCoins;
			vacation.agency_id = $scope.agency.id;
			
			return VacationService.save(vacation).then(function() {
				MoneyTransferService.transferFromDrawer($scope.agency.id, $localStorage.user.id, vacation.stopTransfer)
			})
		}).then(function () {
			delete $scope.currentVacation
			reinitBillsAndCoins() 
			Toaster.show('La vacation a été fermée et enregistrée')
			return getAllActiveVacation()
		})
	}
	
	var _getNonValidatedBusinessDay = function(agencyId) {
		return BusinessDayService.getByAgencyId(agencyId).then(function(businessDays) {
			return _.filter(businessDays, function(businessDay){
				return businessDay.isoDate !== isoDate && businessDay.validated === false;
			})
		})
	}



	var p1 = ConfigService.all().then(function (config) {

		var loadCurrentAmount = function(){
			return MoneyTransferService.findByAgencyId(config.agencyId).then(function (listeMoneyTransfer){
				$scope.moneyTransfers = listeMoneyTransfer
				var lastElemListeMoneyTransfer =  _.chain(listeMoneyTransfer)
					.sortBy('updated_at')
					.last()
					.value()

				if(lastElemListeMoneyTransfer !== null && _.size(lastElemListeMoneyTransfer) > 0){
					$scope.currentAmount = lastElemListeMoneyTransfer.current
				} else {
					$scope.currentAmount = 0
				}
				$scope.isPositifCurrentAmount = $scope.currentAmount >= 0
			})
		}

		loadCurrentAmount()

		if (!targetVacationId) {
			return _getNonValidatedBusinessDay(config.agencyId).then(function(nonValidatedBusinessDays) {
				$scope.canOpen = true
				if (nonValidatedBusinessDays && nonValidatedBusinessDays.length > 0) {
					console.warn('nonValidatedBusinessDays',nonValidatedBusinessDays);
					$scope.canOpen = false
				}
				return BusinessDayService.getByAgencyIdAndByDate(config.agencyId, isoDate)
			}).then(function (businessDay) {
				$scope.businessDay = businessDay
				if(!businessDay.isValidated()){
                    Drawer.open()
                }
			}, function () {
				$scope.businessDay = new BusinessDay({
					agency_id: 	config.agencyId,
				})
				$scope.businessDay.date = isoDate
				BusinessDayService.save(config.agencyId, $scope.businessDay);
				
			}).then(function () {
				return VacationService.findByIdUser($localStorage.user.id, {isOnGoing : true}).then(function(vacations){
					if (vacations && vacations.length > 0) {
						$scope.selectionVacation(vacations[0])
					}
					else {
						VacationService.findByAgencyId(config.agencyId).then(function (vacations) {
							vacations = _.filter(vacations, function (vacation) {
								return !vacation.endStateId
							})
							
							if (vacations.length > 0) {
								$scope.selectionVacation(vacations[0])
							}
						})
					}

					$scope.closeVacation = _closeVacation
					return getAllActiveVacation()
				})
			})
		} else {
			return VacationService.find(config.agencyId, targetVacationId).then(function (vacation) {
				$scope.selectionVacation(vacation)
				$scope.closeVacation = _closeVacation
				Drawer.open()
			})
		}
	})
	
	$scope.inputVacationChange = function() {
		$scope.startTotal = ($scope.vacation.amountStart ? +$scope.vacation.amountStart : 0) + ($scope.vacation.startTransfer ? +$scope.vacation.startTransfer : 0);
	}
	
	$scope.openVacation = function() {
		if (!$scope.startTotal) {
			return
		}
		
		var lastVacation = null;
		
		ConfigService.all().then(function (configs) {
			return VacationService.findByAgencyId(configs.agencyId, { filter: { last: true } }).then(function (vacations) {
				if (!vacations || vacations.length === 0) {
					return null;
				}
				lastVacation = VacationDecorator(vacations[0]);
			});
		}).finally(function() {
			if (lastVacation) {
				var amountStop = lastVacation.stop_total - (+lastVacation.stopTransfer || 0)
				if (amountStop !== +$scope.vacation.amountStart) {
					//Toaster.danger("Le montant du fond de caisse est incorrect. Veuillez en référer à votre responsable d'agence")
					var symbolCurrency = $scope.agency.currency.symbol
					$scope.vacation.validation_comment = " "
				}
			}
			
			VacationService.create($localStorage.user.id, $scope.vacation).then(function() {
				MoneyTransferService.transferToDrawer($scope.agency.id, $localStorage.user.id, $scope.vacation.startTransfer)
			}).finally(function() {
				$state.go('app.shop')
			})
		})
	}
	
	$scope.selectionVacation = function(vacation){
		ConfigService.all().then(function (configs) {

			SaleService.findByVacationId(configs.agencyId, vacation.id).then(function (sales) {
                var pool = []
                sales.forEach(function (sale) {
                    var p = TransactionService.find(configs.agencyId, sale.transactionId).then(function (transaction) {
                        sale.transaction = transaction
                        return sale
                    })

                    pool.push(p)
                })

                return $q.all(pool)
            }).then(function (sales) {
                $scope.sales = _.chain(sales).filter(function (sale) {
                    return sale.transaction.finished
                }).value()


                $scope.totalSales = Sale.totalPrice($scope.sales)
                $scope.updateInventory()
            })

            $scope.vacationOngoing = moment(vacation.dateStart).calendar()

            vacation.stopTransfer = 0
            $scope.currentVacation = vacation


		})
	}
	
	$scope.cumulated = 0
	$scope.target = 0
	$scope.isBalanced = false
	var p2 = ConfigService.all().then(function (configs) {
		$rootScope.configs = configs
	}).then(function () {
		reinitBillsAndCoins()
	})

	$scope.updateInventory = function () {
		$scope.cumulated = Cash.cumulate($scope.coins, $scope.bills);
		$scope.target = $scope.currentVacation.amountStart + ($scope.currentVacation.startTransfer || 0) + (+$scope.totalSales);
		$scope.isBalanced = $scope.target - $scope.cumulated === 0;

		$scope.currentVacation.stopDrawer = $scope.cumulated
	}

  	$q.all([p1, p2]).finally(function () {
		$scope.pageLoaded = true
  	})
}])
